"use client"

import { LogIn, UserPlus } from "lucide-react"
import React, { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";

const Header = () => {
    const {
        setScreen,
    } = useContext(RegistrationContext);
    return (
        <header className="bg-white shadow-sm">
            <div className="container mx-auto px-4 py-4 flex justify-between items-center">
                <div className="flex items-center">
                    <h1 className="text-xl font-bold tracking-tight">
                        <span className="font-extrabold">IJCAI</span>
                        <span className="text-blue-600 font-extrabold"> Registration</span>
                        <span className="block text-sm font-medium text-gray-500 -mt-1">System</span>
                    </h1>
                </div>
                <div className="flex items-center gap-6">
                    {/* <a href="#" className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors">
                        <Info className="h-4 w-4 mr-1" />
                        Conference info
                    </a> */}
                    <button onClick={() => setScreen("login")} className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors">
                        <LogIn className="h-4 w-4 mr-1" />
                        Log in
                    </button>

                    <button  onClick={() => setScreen("signin")} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors"                    >
                        <UserPlus className="h-4 w-4 mr-1" />
                        Sign up
                    </button>
                </div>
            </div>
        </header>
    );

}

export default Header;